import "./RdoSkeletons.css";

export default function RdoSkeleton() {

    return (

        <div className="rdo-skeleton">

            {/* Header */}
            <div className="sk-card">
                <div className="sk sk-title"></div>
                <div className="sk sk-subtitle"></div>
            </div>

            {/* Informações */}
            <div className="sk-card">

                <div className="sk-row">
                    <div className="sk sk-input"></div>
                    <div className="sk sk-input"></div>
                </div>

                <div className="sk-row">
                    <div className="sk sk-input"></div>
                    <div className="sk sk-input"></div>
                    <div className="sk sk-small"></div>
                </div>

            </div>

            {/* Clima */}
            <div className="sk-card">

                <div className="sk sk-section"></div>

                <div className="sk sk-table"></div>
                <div className="sk sk-table"></div>

            </div>

            {/* Atividades */}
            <div className="sk-card">

                <div className="sk sk-section"></div>

                {[...Array(6)].map((_, i) => (

                    <div className="sk-atividade" key={i}>

                        <div className="sk sk-pavimento"></div>

                        <div className="sk sk-textarea"></div>

                    </div>

                ))}

            </div>

        </div>

    );

}